var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tnc-wrapper" },
    [
      _vm._m(0),
      _vm._m(1),
      _vm._m(2),
      _vm._m(3),
      _vm._m(4),
      _vm._m(5),
      _vm._m(6),
      _vm.isMobile ? _c("BurgerMenu") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h2", [
      _c("span", { staticStyle: { "font-size": "16pt" } }, [
        _vm._v("Syarat & Ketentuan"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("Aturan umum"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Situs web kami hanya dibatasi untuk individu dengan usia legal sebagaimana ditentukan dalam yurisdiksi tempat individu tersebut tinggal."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Situs web kami tidak bertanggung jawab atas hukum nasional, hukum federal, atau hukum internasional apa pun yang dilanggar oleh pengguna mana pun yang menggunakan situs web kami."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Pengguna bertanggung jawab atas tindakan mereka sendiri dan terikat oleh undang-undang negara mereka sendiri, yang mencakup undang-undang negara bagian atau masalah hukum."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Semua agen bertanggung jawab atas akun anggotanya masing-masing, dan akan menghormati semua taruhan yang dikonfirmasi yang dikirimkan oleh mereka."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Agen bukanlah mitra website Kami. Oleh karena itu situs kami tidak bertanggung jawab atas perbedaan atau perselisihan apa pun antara Pemain dan Agen."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Merupakan tanggung jawab pengguna untuk menjaga ID Pengguna dan Kata Sandinya dari penggunaan yang tidak sah. Jika ID Pengguna dan Kata Sandi pengguna dicuri atau dibobol, pengguna bertanggung jawab untuk segera menghubungi agennya. Agen kemudian akan mengubah User ID dan Password penggunanya."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Jika terjadi pencurian ID Pengguna dan Kata Sandi, pengguna bertanggung jawab atas akunnya masing-masing dan akan menghormati semua taruhan yang dikonfirmasi yang diajukan."
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("Aturan Permainan"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Hasil pertandingan yang diputuskan oleh website kami bersifat final dan mengikat."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Dalam semua kasus perselisihan, baik manajemen situs web Kami maupun pemain harus menyetujui bahwa basis data log transaksi situs web Kami akan berfungsi sebagai penengah terakhir dalam perselisihan tersebut. Semua perselisihan harus diajukan pada hari dimana hasil pertandingan ditentukan. Tidak ada klaim yang akan dipenuhi setelah hari pertandingan."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Pemain bertanggung jawab penuh untuk memverifikasi keakuratan semua transaksi akun mereka."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Harap pastikan untuk meninjau taruhan Anda untuk setiap kesalahan, kesalahan atau kelalaian sebelum mengirimkannya melalui komputer. Setelah taruhan diterima melalui komputer, taruhan tersebut tidak dapat diubah atau dibatalkan."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Kami berhak membekukan atau membatalkan akun pelanggan mana pun yang ditemukan melanggar Syarat dan Ketentuan ini, terlibat dalam aktivitas penipuan, masuk tanpa izin, menyerang, memalsukan, merusak aturan standar, atau terlibat dalam sindikat taruhan, yang mengakibatkan semua saldo akun dibekukan dan hangus. tanpa pemberitahuan sebelumnya."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Kami berhak membatalkan atau menyatakan tidak sah setiap taruhan atau tiket yang diketahui berkaitan dengan taruhan sindikat, taruhan terkoordinasi, kolusi, penipuan, penyalahgunaan sistem, pemanfaatan kesalahan teknis, odds yang keliru, atau upaya lain untuk memperoleh keuntungan yang tidak adil. Setiap kemenangan terkait dapat dibatalkan, dan akun terkait dapat ditangguhkan atau ditutup."
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("Batasan dan Kewajiban"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Tanpa mengurangi ketentuan umum di atas, Situs web Kami tidak akan bertanggung jawab kepada siapa pun jika terjadi sabotase, force majeure, dan/atau atas peristiwa kegagalan atau kerusakan atau kehancuran pada sistem komputer pusat atau catatan atau bagian mana pun dari situs web Kami. daripadanya, atau penundaan, kehilangan, kesalahan, kelalaian atau hal lainnya yang disebabkan oleh kegagalan sistem telekomunikasi atau transmisi data apa pun, atau penundaan apa pun yang mengakibatkan tidak diterimanya entri apa pun untuk perlombaan tertentu."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Situs web kami tidak bertanggung jawab atas segala kerugian yang disebabkan oleh takdir Tuhan, pecahnya permusuhan, kerusuhan, kerusuhan sipil, aksi terorisme, tindakan pemerintah atau pihak berwenang (termasuk penolakan atau pencabutan lisensi atau persetujuan apa pun), ledakan kebakaran, banjir, pencurian, pengrusakan berbahaya, pemogokan, penutupan perusahaan dan tindakan industrial dalam bentuk apa pun."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Jika terjadi kesalahan koneksi jaringan, komunikasi, sistem atau manusia yang menyebabkan masalah terkait taruhan seperti penerimaan taruhan ganda, taruhan tidak dapat dikonfirmasi, memasang taruhan setelah pertandingan dimulai, dll. Kami berhak jika terjadi hal tersebut kesalahan untuk mengatasinya berdasarkan kasus per kasus dan juga untuk mengambil tindakan lain untuk memperbaiki kesalahan tersebut. Kami tidak bertanggung jawab kepada Anda atau pihak ketiga mana pun sehubungan dengan kesalahan tersebut. Jika Anda pernah mengalami kesalahan tersebut dan terus bertaruh tanpa melapor ke upline Anda, Anda akan bertanggung jawab dan menghormati semua hasil menang/kalah jika kesalahan tersebut terjadi lagi."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Peraturan dan Ketentuan ini merupakan keseluruhan kesepakatan dan kesepahaman antara para pihak."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "Apabila terdapat perbedaan antara versi bahasa Inggris dari Peraturan dan Regulasi ini dengan versi bahasa lainnya, maka versi bahasa Inggris akan menggantikan bahasa lainnya dan dianggap benar dan sah."
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }